import DashboardLayout from "components/layouts/dashboard-layout";
import PageLinks from "components/page-links";
import React from "react";
import styled from "styled-components";
import VideoOptions from "./components/video-options";
import VideoProgress from "./components/video-progress";
import VideoStatus from "./components/video-status";
import VideoDetails from "./components/video-details";
import VideoRecordLabel from "./components/video-label";
import VideoStores from "./components/video-stores";

const MusicVideo = () => {
  return (
    <DashboardLayout>
      <>
        <PageLinks
          from={{ name: "Rated Tube", link: "/overview/rated-tube" }}
          current="video Name"
        />
        <Flexbox>
          <VideoProgress /> <VideoOptions />
        </Flexbox>
        <VideoStatus
          type="in-progress"
          message="Your EP is currently under review or has already been delivered to stores and is now waiting to go live on the scheduled release date."
        />
        <VideoDetails />
        <VideoRecordLabel label="Rated Afrika" year="2024" />
        <VideoStores />
      </>
    </DashboardLayout>
  );
};

export default MusicVideo;

const Flexbox = styled.div`
  display: grid;
  justify-content: space-between;
  align-items: center;
  grid-template-columns: auto auto;
  margin-top: 3.2rem;
  @media only screen and (max-width: 769px) {
    grid-template-columns: auto;
    grid-row-gap: 3rem;
    margin-top: 2.4rem;
  }
`;
